var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-base d-flex flex-column"},[_c('nav-header'),_c('router-view',{style:({'min-height' : _vm.clientHeight + 'px'})}),(_vm.showFooter)?_c('nav-footer',{attrs:{"id":"footer"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }